import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=283ce920&scoped=true"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=283ce920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ce920",
  null
  
)

export default component.exports